import { useTranslationContext } from '@/hooks/useTranslation';
import { languages, Language } from '@/hooks/useTranslation';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

export function LanguageSelector() {
  const { currentLanguage, setLanguage, t } = useTranslationContext();

  return (
    <div className="space-y-2">
      <Label>{t('language')}</Label>
      <Select value={currentLanguage} onValueChange={(value) => setLanguage(value as Language)}>
        <SelectTrigger>
          <SelectValue>
            <div className="flex items-center space-x-2">
              <span>{languages[currentLanguage].flag}</span>
              <span>{languages[currentLanguage].name}</span>
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {Object.entries(languages).map(([code, lang]) => (
            <SelectItem key={code} value={code}>
              <div className="flex items-center space-x-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}